module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("SubscriptionTransfer", "Transfer subscription") ))==null?'':__t)+
'</legend><p>'+
((__t=(i18n.tc("SubscriptionTransfer", "Would you like to transfer the subscription for %s to someone else? The recipient will have to accept the transfer before the move is executed.").format(transientAlias) ))==null?'':__t)+
'</p><div><label for="transfer-email-input">'+
((__t=( i18n.tc("SubscriptionTransfer", "Email address:") ))==null?'':__t)+
'</label> <input type="text" id="transfer-email-input" data-input="transfer-email" required></div></fieldset><fieldset class="button-wrap"><button data-click="transfer-cancel">'+
((__t=( i18n.tc("SubscriptionTransfer", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="transfer-close" hidden>'+
((__t=( i18n.tc("SubscriptionTransfer", "Close") ))==null?'':__t)+
'</button> <button class="primary" data-click="transfer-submit" disabled="disabled">'+
((__t=( i18n.tc("SubscriptionTransfer", "Transfer") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
